import TaxiBookingWebsite from "./comp/TaxiBookingWebsite.jsx";

function App() {
  return (
    <div>
      <TaxiBookingWebsite />
    </div>
  );
}

export default App;
